// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"94043007","977":"3d02f3c3"}[chunkId] + ".chunk.js";
};